/*
 * Static theme: the compiled @grapevinetrvl/<VUE_APP_THEME> package when one is
 * installed, otherwise the neutral in-repo theme (src/themes/generic.js). A
 * tenant without a package (talma) therefore builds and boots; its real look
 * arrives at runtime from Airtable through the branding store, which layers
 * over whatever this exports. Components should read `brand` from that store,
 * not this object, so both sources render through the same path.
 */
import { theme as generic } from '@/themes/generic';

function loadPackagedTheme() {
  try {
    // Keep process.env.VUE_APP_THEME inline: DefinePlugin folds it to a literal,
    // so webpack sees a static require of one package. Hoisting it into a
    // variable makes webpack bundle a context over every file under
    // node_modules/@grapevinetrvl (README, favicon...) and the build fails.
    // A package that is not installed is a build warning (require inside try)
    // and a MODULE_NOT_FOUND at runtime, which is what the catch is for.
    return require(`@grapevinetrvl/${
      process.env.VUE_APP_THEME
        ? process.env.VUE_APP_THEME
        : 'marvin-generic-fe'
    }`).theme;
  } catch (error) {
    return null;
  }
}

// talma/talmactx have no compiled package and are MEANT to fall through to the
// generic theme (their look arrives from Airtable at runtime). Every other tenant
// has one, and a lost or typo'd VUE_APP_THEME would otherwise render a
// working-but-wrong site - neutral colour, no logo, tmc "undefined" on every
// query - with nothing in the console. Say so loudly instead.
function warnIfPackageExpected(loaded) {
  const name = process.env.VUE_APP_THEME;
  // Under jest the require fails for everyone - the packages import .svg/.png,
  // which only webpack resolves - so the warning would be pure noise there.
  if (
    loaded ||
    !name ||
    process.env.NODE_ENV === 'test' ||
    process.env.VUE_APP_BRANDING_SOURCE === 'airtable'
  ) {
    return;
  }
  // eslint-disable-next-line no-console
  console.error(
    `Theme package @grapevinetrvl/${name} failed to load; falling back to the ` +
      'generic theme. Check VUE_APP_THEME and that the package is installed.'
  );
}

const packagedTheme = loadPackagedTheme();
warnIfPackageExpected(packagedTheme);

export const theme = packagedTheme || generic;
